module.exports = __webpack_public_path__ + "img/JHSLS_common.846455bb.png";